module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bread"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("研究会")]), _c('el-breadcrumb-item', [_vm._v("比赛平台")])], 1)], 1), _c('div', {
    staticClass: "carousel"
  }, [(_vm.carousels.length > 0) ? _c('el-carousel', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "interval": 5000,
      "height": "460px",
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.8)"
    }
  }, _vm._l((_vm.carousels), function(item, index) {
    return _c('el-carousel-item', {
      key: index
    }, [(item.background) ? _c('img', {
      attrs: {
        "src": item.background,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.palaceholder
      }
    }), _c('div', {
      staticClass: "background"
    }, [_c('h2', [_c('strong', [_vm._v(_vm._s(item.title))])]), _c('el-button', {
      staticClass: "todoBtn",
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail(item.id, 'compete')
        }
      }
    }, [_vm._v("新闻动态")])], 1)])
  }), 1) : _vm._e(), _c('el-row', {
    staticClass: "competes-content",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-row', {
    staticClass: "competes-content",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "xs": 24,
      "sm": 24,
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.8)"
    }
  }, [_c('Container', {
    staticClass: "container-item",
    attrs: {
      "showMore": _vm.competes.length >= 6,
      "title": "往届比赛",
      "footer": "更多比赛"
    },
    on: {
      "getMore": _vm.getMoreCompete
    }
  }, [(_vm.competes.length != 0) ? _c('el-row', {
    staticClass: "topics-el-row"
  }, _vm._l((_vm.competes), function(item, index) {
    return _c('el-col', {
      key: index,
      staticClass: "topics-el-col",
      attrs: {
        "xs": 24,
        "sm": 6
      }
    }, [_c('div', {
      staticClass: "grid-content img-content",
      on: {
        "click": function($event) {
          return _vm.showDetail(item.id, 'compete')
        }
      }
    }, [(item.background) ? _c('img', {
      attrs: {
        "src": item.background,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.palaceholder
      }
    }), _c('div', {
      staticClass: "title signle-line"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.desc))]), _c('div', {
      staticClass: "comp-time"
    }, [_vm._v(_vm._s(_vm.$utils.dateTimeString(item.created_at)))])])])
  }), 1) : _c('div', {
    staticClass: "topics-news-content"
  }, [_c('div', {
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": "/static/empty.svg",
      "alt": ""
    }
  }), _c('p', [_vm._v("暂无比赛")])])])], 1)], 1)], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0d0fb96","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Compete/Competes.vue
// module id = 2086
// module chunks = 42